import React, {useContext} from 'react';
import Post from './Post';
import { PostContext } from '../context/PostContext';

const PostList= ()=>{
const {state,dispatch}=useContext(PostContext);

return(
    <div className="feed-container">
    <h1>Feed</h1>
    {state.posts.map((post,index)=>(
        <Post
        key={index}
        post={post}
        handleDeletePost={()=>dispatch({type: 'DELETE_POST', payload: index})}
        index= {index}
        />
    ))}</div>
);
};

export default PostList;